import { useNavigate } from "react-router-dom";
import { ChangeEvent, useState, useEffect } from "react";
import {useSelector} from "react-redux";
import { MarketplaceWrapper } from "../styles/marketplace";
import Modal from '@mui/material/Modal';
import { Box, FormControl, TextField, Button, Stack } from "@mui/material";
import Typography from '@mui/material/Typography';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { Row } from "reactstrap";
import DateTimePicker from '@mui/lab/DateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import detectEthereumProvider from "@metamask/detect-provider";
import Web3 from "web3";
import WalletConnectProvider from "@walletconnect/web3-provider";
import QRCodeModal from "@walletconnect/qrcode-modal";
import WalletConnect from "@walletconnect/client";

const contractAdress = "0x1ED46A7436E5ff19d7dd8fbe7eE825c7f1395459";
const nftAddress = "0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB";
const abi = [{"inputs":[{"internalType":"address","name":"_bidToken","type":"address"},{"internalType":"uint256","name":"_feeRatio","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"nftContract","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"AuctionCanceled","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"bidder","type":"address"},{"indexed":false,"internalType":"uint256","name":"bid","type":"uint256"},{"indexed":false,"internalType":"address","name":"nftContract","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"NewBid","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"withdrawer","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"address","name":"nftContract","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"WithdrawFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"withdrawer","type":"address"},{"indexed":false,"internalType":"address","name":"nftContract","type":"address"},{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"WithdrawToken","type":"event"},{"inputs":[{"internalType":"address","name":"_newNFTAddress","type":"address"}],"name":"addNewContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_auctionId","type":"uint256"}],"name":"allBids","outputs":[{"internalType":"address[]","name":"","type":"address[]"},{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"auctions","outputs":[{"internalType":"address","name":"creator","type":"address"},{"internalType":"uint256","name":"startPrice","type":"uint256"},{"internalType":"uint256","name":"maxBid","type":"uint256"},{"internalType":"address","name":"maxBidder","type":"address"},{"internalType":"uint256","name":"directBuyPrice","type":"uint256"},{"internalType":"uint256","name":"minIncrement","type":"uint256"},{"internalType":"bool","name":"isDirectBuy","type":"bool"},{"internalType":"bool","name":"isCancelled","type":"bool"},{"internalType":"uint256","name":"endTime","type":"uint256"},{"internalType":"address","name":"nftAddress","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"feeRatio","type":"uint256"},{"internalType":"uint256","name":"auctionId","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_nftContract","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"cancelAuction","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_endTime","type":"uint256"},{"internalType":"uint256","name":"_minIncrement","type":"uint256"},{"internalType":"uint256","name":"_directBuyPrice","type":"uint256"},{"internalType":"uint256","name":"_startPrice","type":"uint256"},{"internalType":"address","name":"_nftAddress","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"createAuction","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_nftContract","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"exchangeAssets","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_lastNumber","type":"uint256"}],"name":"getAuctionInfo","outputs":[{"internalType":"uint256[]","name":"directBuy","type":"uint256[]"},{"internalType":"address[]","name":"owner","type":"address[]"},{"internalType":"uint256[]","name":"highestBid","type":"uint256[]"},{"internalType":"address[]","name":"highestBidder","type":"address[]"},{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"internalType":"uint256[]","name":"endTime","type":"uint256[]"},{"internalType":"uint256[]","name":"startPrice","type":"uint256[]"},{"internalType":"uint256[]","name":"auctionStates","type":"uint256[]"},{"internalType":"address[]","name":"auctionNFTAddress","type":"address[]"},{"internalType":"uint256[]","name":"auctionIds","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getAuctionNumber","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_auctionId","type":"uint256"}],"name":"getAuctionState","outputs":[{"internalType":"enum AuctionManagerCustomToken.AuctionState","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getBidToken","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_lastNumber","type":"uint256"}],"name":"getClaimableBids","outputs":[{"internalType":"uint256[]","name":"highestBid","type":"uint256[]"},{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"internalType":"address[]","name":"auctionNFTAddress","type":"address[]"},{"internalType":"uint256[]","name":"auctionIds","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_lastNumber","type":"uint256"}],"name":"getClaimableNFTs","outputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"internalType":"address[]","name":"auctionNFTAddress","type":"address[]"},{"internalType":"uint256[]","name":"auctionIds","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getFeeRatio","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNFTList","outputs":[{"internalType":"address[]","name":"","type":"address[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_lastNumber","type":"uint256"}],"name":"getUserAuctions","outputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"internalType":"address[]","name":"auctionNFTAddress","type":"address[]"},{"internalType":"uint256[]","name":"auctionIds","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_nftContract","type":"address"}],"name":"getUserTokenIds","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"isClaimed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"nftContractAuctions","outputs":[{"internalType":"address","name":"creator","type":"address"},{"internalType":"uint256","name":"startPrice","type":"uint256"},{"internalType":"uint256","name":"maxBid","type":"uint256"},{"internalType":"address","name":"maxBidder","type":"address"},{"internalType":"uint256","name":"directBuyPrice","type":"uint256"},{"internalType":"uint256","name":"minIncrement","type":"uint256"},{"internalType":"bool","name":"isDirectBuy","type":"bool"},{"internalType":"bool","name":"isCancelled","type":"bool"},{"internalType":"uint256","name":"endTime","type":"uint256"},{"internalType":"address","name":"nftAddress","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"feeRatio","type":"uint256"},{"internalType":"uint256","name":"auctionId","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"nftContracts","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"nftContractsList","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_nftContract","type":"address"},{"internalType":"uint256","name":"_tokenId","type":"uint256"},{"internalType":"uint256","name":"_bidValue","type":"uint256"}],"name":"placeBid","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"newFeeRatio","type":"uint256"}],"name":"setFeeRatio","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"}];

const abi3 = [{"inputs":[{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"string","name":"baseTokenURI","type":"string"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"MAX_SUPPLY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"},{"internalType":"uint256","name":"_allowedNFTCount","type":"uint256"}],"name":"addAllowedAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getAllowedAddress","outputs":[{"components":[{"internalType":"address","name":"allowedAddress","type":"address"},{"internalType":"uint256","name":"initialBalance","type":"uint256"},{"internalType":"uint256","name":"remainingBalance","type":"uint256"}],"internalType":"struct HC_NFT_Base.Info","name":"","type":"tuple"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"getMintableNFTBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_address","type":"address"}],"name":"removeAllowedAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"string","name":"baseTokenURI","type":"string"}],"name":"setBaseURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalRemainingSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"}];

const { ethereum } = window;

const HoV_RACE_GENDER_HUMAN_MALE = 1;
const HoV_RACE_GENDER_HUMAN_FEMALE = 2;
const HoV_RACE_GENDER_ORC_MALE = 3;
const HoV_RACE_GENDER_ORC_FEMALE = 4;
const HoV_RACE_GENDER_ELF_MALE = 5;
const HoV_RACE_GENDER_ELF_FEMALE = 6;
const HoV_RACE_GENDER_DWARF_MALE = 7;
const HoV_RACE_GENDER_DWARF_FEMALE = 8;

const HoV_CLASS_WARRIOR = 1;
const HoV_CLASS_RANGER = 2;
const HoV_CLASS_MAGE = 3;
const HoV_CLASS_ASSASSIN = 4;
const HoV_CLASS_TANK = 5;
const HoV_CLASS_CLERIC = 6;

const Wallet = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [forsale, setForsale] = useState(true);
  const [endTime, setEndTime] = useState(Date());
  const [minIncrement, setMinIncrement] = useState();
  const [directBuyPrice, setDirectBuyPrice] = useState();
  const [startPrice, setStartPrice] = useState();
  const [currentTokId, setCurrentTokId] = useState();
  const [currentNftAdd, setCurrentNftAdd] = useState();
  const [pleaseWait, setPleaseWait] = useState(true);
  const [currentBids, setCurrentBids] = useState([]);
  const [currentNfts, setCurrentNfts] = useState([]);
  const [myNfts, setMyNfts] = useState([]);
  const [gameNfts, setGameNfts] = useState([]);
  const [betaNfts, setBetaNfts] = useState([]);
  const [nftAttribute, setNftAttribute] = useState([]);
  const [openNfts, setOpenNfts] = useState([]);
  const [bugsNfts, setBugsNfts] = useState([]);
  const [alignment, setAlignment] = useState('directbuy');
  const {publicKey, walletType} = useSelector(state => state.wallet);



  const modalAucOpen = (nftid, nftCurAddress) => {
    if(nftCurAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB") {
      var requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      
      fetch("https://mayinhara.s3.eu-central-1.amazonaws.com/"+nftid+".json", requestOptions)
        .then(response => response.text())
        .then(result => 
          {console.log(result)
            var alljson = JSON.parse(result);
            setNftAttribute(alljson.attributes);
          }
        )
        .catch(error => console.log('error', error));

    } else if(nftCurAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41") {
      var requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      
      fetch("https://fov.heroeschained.com/api/NFT/FOV/"+nftid, requestOptions)
        .then(response => response.text())
        .then(result => 
          {console.log(result)
            var alljson = JSON.parse(result);
            setNftAttribute(alljson.attributes);
          }
        )
        .catch(error => console.log('error', error));
    } else {
      setNftAttribute([]);
    }


    document.getElementById("minincrementid").style.display = "none";
    document.getElementById("startpriceid").style.display = "none";
    setCurrentTokId(nftid);
    setCurrentNftAdd(nftCurAddress);
    handleModal();
  }
  const handleModal = () => { setOpen(!open);};


  const createAuc = async () => {
    if(startPrice == 0) {
      alert("You set the starting price to 0. Please be aware of this and proceed with the process!")
    }
    if(walletType=="metamask" || walletType=="") {
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      const nftInterface = new web3Instance.eth.Contract(abi3,currentNftAdd);
      const date1 = new Date();
      const diffTime = (Math.abs(endTime - date1)).toString();
      let ddd = diffTime.slice(0, -3);

      const minIncrement1 = (minIncrement * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const directBuyPrice1 = (directBuyPrice * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const startPrice1 = (startPrice * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const fakestartprice = (0* (10 ** 18)).toString();
      await nftInterface.methods.setApprovalForAll(contractAdress, true).send({from: ethereum.selectedAddress});
      if(alignment=="auction") {
        await abiInterface.methods.createAuction(ddd, minIncrement1, directBuyPrice1, startPrice1, currentNftAdd, currentTokId).send({ from: ethereum.selectedAddress });
        handleModal();
        window.location.reload();
      } else {
        await abiInterface.methods.createAuction(ddd, directBuyPrice1, directBuyPrice1, fakestartprice, currentNftAdd, currentTokId).send({ from: ethereum.selectedAddress });
        handleModal();
        window.location.reload();
      }
     

    } else if (walletType=="walletconnect") {
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
  
      await provider.enable();
      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      const nftInterface = new web3Instance.eth.Contract(abi3,currentNftAdd);
      const date1 = new Date();
      const diffTime = (Math.abs(endTime - date1)).toString();
      let ddd = diffTime.slice(0, -3);

      const minIncrement1 = (minIncrement * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const directBuyPrice1 = (directBuyPrice * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const startPrice1 = (startPrice * (10 ** 18)).toLocaleString('fullwide', {useGrouping:false});
      const fakestartprice = (0* (10 ** 18)).toString();
      await nftInterface.methods.setApprovalForAll(contractAdress, true).send({from: accounts[0]});
      if(alignment=="auction") {
        await abiInterface.methods.createAuction(ddd, minIncrement1, directBuyPrice1, startPrice1, currentNftAdd, currentTokId).send({ from: accounts[0] });
        handleModal();
        window.location.reload();
      } else {
        await abiInterface.methods.createAuction(ddd, directBuyPrice1, directBuyPrice1, fakestartprice, currentNftAdd, currentTokId).send({ from: accounts[0] });
        handleModal();
        window.location.reload();
      }
    }

  }

 
const parseFoVTokenID = (token_id) => {
  if (token_id.length != 18)
    return "";

  try {
    var token_type = token_id.substr(0, 1);
    var stat_type = parseInt(token_id.substr(1, 1));
    var upgrade_amount = parseInt(token_id.substr(2, 1));
  
    var name = "";
    var short_name = "";

    if (token_type == "1") {
      if (upgrade_amount < 1 || upgrade_amount > 5)
    return "";

  if (stat_type != 1 && stat_type != 2)
        return "";

      var duration_hours = parseInt(token_id.substr(3, 7)) / (60);

      if (stat_type == 1) 
        short_name = "AP";
      else if (stat_type == 2) 
        short_name = "DP";                    

      name = "Training Ticket " + short_name + "+" + upgrade_amount + " (" + duration_hours + " hours)";
    }
    else if (token_type == "2") {
      if (upgrade_amount < 1 || upgrade_amount > 5)
    return "";

      if (stat_type < 1 || stat_type > 4)
        return "";

      if (stat_type == 1) 
        short_name = "AP";                    
      else if (stat_type == 2) 
        short_name = "DP";                    
      else if (stat_type == 3) 
        short_name = "EL";                    
      else if (stat_type == 4) 
        short_name = "MEGA";                    

      name = "Gemstone " + short_name + "+" + upgrade_amount;
    }
  else if (token_type == "3") {
  var HoV_RACE_gender_id = parseInt(token_id.substr(1, 1));
  var HoV_CLASS_id = parseInt(token_id.substr(2, 1));

  if (HoV_RACE_gender_id < HoV_RACE_GENDER_HUMAN_MALE || HoV_RACE_gender_id > HoV_RACE_GENDER_DWARF_FEMALE)
    return "";

  if (HoV_CLASS_id < HoV_CLASS_WARRIOR || HoV_CLASS_id > HoV_CLASS_CLERIC)
    return "";

  return Get_Gender_Text(HoV_RACE_gender_id) + " " + Get_HoV_RACE_Text(HoV_RACE_gender_id) + " - " + Get_HoV_CLASS_Text(HoV_CLASS_id);
  }

    return name;
  }
  catch (ex) {
    return "";
  }
}

  
const Get_HoV_CLASS_Text = (ptype) => {
if (ptype == HoV_CLASS_WARRIOR)
  return "Warrior";
else if (ptype == HoV_CLASS_RANGER)
  return "Ranger";
else if (ptype == HoV_CLASS_MAGE)
  return "Mage";
else if (ptype == HoV_CLASS_ASSASSIN)
  return "Assassin";
else if (ptype == HoV_CLASS_TANK)
  return "Tank";
else if (ptype == HoV_CLASS_CLERIC)
  return "Cleric";

return "";
}

const Get_Gender_Text = (ptype) => {
if (ptype == HoV_RACE_GENDER_DWARF_MALE || ptype == HoV_RACE_GENDER_ELF_MALE || ptype == HoV_RACE_GENDER_HUMAN_MALE || ptype == HoV_RACE_GENDER_ORC_MALE)
  return "Male";
else if (ptype == HoV_RACE_GENDER_DWARF_FEMALE || ptype == HoV_RACE_GENDER_ELF_FEMALE || ptype == HoV_RACE_GENDER_HUMAN_FEMALE || ptype == HoV_RACE_GENDER_ORC_FEMALE)
  return "Female";

return "";
}

const Get_HoV_RACE_Text = (ptype) => {
if (ptype == HoV_RACE_GENDER_DWARF_MALE || ptype == HoV_RACE_GENDER_DWARF_FEMALE)
  return "Dwarf";
else if (ptype == HoV_RACE_GENDER_ELF_MALE || ptype == HoV_RACE_GENDER_ELF_FEMALE)
  return "Elf";
else if (ptype == HoV_RACE_GENDER_HUMAN_MALE || ptype == HoV_RACE_GENDER_HUMAN_FEMALE)
  return "Human";
else if (ptype == HoV_RACE_GENDER_ORC_MALE || ptype == HoV_RACE_GENDER_ORC_FEMALE)
  return "Orc";

return "";
}

  const claimBid = async (auctionadd, nfttoken) => {
    if(walletType=="metamask" || walletType=="") {
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      await abiInterface.methods.exchangeAssets(auctionadd,nfttoken).send({from: ethereum.selectedAddress});
      window.location.reload();

    } else if (walletType=="walletconnect") {
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
  
      await provider.enable();
      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      await abiInterface.methods.exchangeAssets(auctionadd,nfttoken).send({from: accounts[0]});
      window.location.reload();
    }
  }


  const cancelAuction = async (auctionadd, nfttoken) => {
    if(walletType=="metamask" || walletType=="") {
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      await abiInterface.methods.cancelAuction(auctionadd,nfttoken).send({from: ethereum.selectedAddress});
      window.location.reload();

    } else if (walletType=="walletconnect") {
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
  
      await provider.enable();
      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      await abiInterface.methods.cancelAuction(auctionadd,nfttoken).send({from: accounts[0]});
      window.location.reload();
    }
  }

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);

    if(newAlignment=="auction"){
      document.getElementById("minincrementid").style.display = "block";
      document.getElementById("startpriceid").style.display = "block";
    } else {
      document.getElementById("minincrementid").style.display = "none";
      document.getElementById("startpriceid").style.display = "none";
    }

  };

  const gotoAssets = (path) => {
    navigate(`/shop/${path}`)
  }

  const getAllNfts = async () => {
    const connector = new WalletConnect({
      bridge: "https://bridge.walletconnect.org", // Required
      qrcodeModal: QRCodeModal,
    });

   
    if(walletType=="metamask" || walletType=="") {
      let allMyNfts =[];
      let allGameNfts =[];
      let allBetaNft =[];
      await ethereum.enable();
      const provider = await detectEthereumProvider();
      const web3Instance = new Web3(provider);
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      let allClaimBids = await abiInterface.methods.getClaimableBids(800).call({from: ethereum.selectedAddress});
      let allClaimNfts = await abiInterface.methods.getClaimableNFTs(800).call({from: ethereum.selectedAddress});
      let allMarketNfts = await abiInterface.methods.getUserAuctions(800).call({from: ethereum.selectedAddress});
    
      let allAuctionsList = await abiInterface.methods.getAuctionInfo(800).call();

      //let allMyNfts = await abiInterface.methods.getUserTokenIds(nftAddress).call({from: ethereum.selectedAddress});

      console.log(allClaimNfts)
      let sortedBids =[];
      let sortedNfts =[];
      let sortedMarket=[];
      let sortedBugsNfts=[];

      for (let i = 0; i < allAuctionsList.auctionIds.length; i++) {
        if((allAuctionsList.owner[i]).toUpperCase()==(ethereum.selectedAddress).toUpperCase() && (allAuctionsList.highestBidder[i]).toUpperCase()==(ethereum.selectedAddress).toUpperCase() && allAuctionsList.auctionStates[i]=="2"){
          let isclaimed = await abiInterface.methods.isClaimed(allAuctionsList.auctionIds[i]).call();
          !isclaimed && sortedBugsNfts.push({
            auctionId: allAuctionsList.auctionIds[i],
            auctionNFTAddress: allAuctionsList.auctionNFTAddress[i],
            tokenId:allAuctionsList.tokenIds[i]
          })
        } 
      }

      for (let i = 0; i < allClaimBids.auctionIds.length; i++) {
        allClaimBids.auctionNFTAddress[i] !="0x0000000000000000000000000000000000000000" && sortedBids.push({
          auctionId: allClaimBids.auctionIds[i],
          highestBid: allClaimBids.highestBid[i],
          auctionNFTAddress: allClaimBids.auctionNFTAddress[i],
          tokenId:allClaimBids.tokenIds[i]
        })
      }

      for (let i = 0; i < allClaimNfts.auctionIds.length; i++) {
        allClaimNfts.auctionNFTAddress[i] !="0x0000000000000000000000000000000000000000" && sortedNfts.push({
          auctionId: allClaimNfts.auctionIds[i],
          auctionNFTAddress: allClaimNfts.auctionNFTAddress[i],
          tokenId:allClaimNfts.tokenIds[i]
        })
      }

      for (let i = 0; i < allMarketNfts.auctionIds.length; i++) {
        allMarketNfts.auctionNFTAddress[i] !="0x0000000000000000000000000000000000000000" && sortedMarket.push({
          auctionId: allMarketNfts.auctionIds[i],
          auctionNFTAddress: allMarketNfts.auctionNFTAddress[i],
          tokenId:allMarketNfts.tokenIds[i]
        })
      }

      var requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      await fetch("https://marketplaceapi.heroeschained.com/getnft?wallet="+ethereum.selectedAddress, requestOptions)
        .then(response => response.text())
        .then(result => {
          var jsonResult = JSON.parse(result);
          allMyNfts = jsonResult;
          console.log(jsonResult);
        })
        .catch(error => console.log('error', error));



        var requestOptions2 = {
          method: 'GET',
          redirect: 'follow'
        };
  
        await fetch("https://marketplaceapi.heroeschained.com/getgamenft?wallet="+ethereum.selectedAddress, requestOptions2)
          .then(response => response.text())
          .then(result => {
            var jsonResult = JSON.parse(result);
            allGameNfts = jsonResult;
            console.log(jsonResult);
          })
          .catch(error => console.log('error', error));

          var requestOptions3 = {
            method: 'GET',
            redirect: 'follow'
          };
    
          await fetch("https://marketplaceapi.heroeschained.com/getbetanft?wallet="+ethereum.selectedAddress, requestOptions3)
            .then(response => response.text())
            .then(result => {
              var jsonResult = JSON.parse(result);
              allBetaNft = jsonResult;
              console.log(jsonResult);
            })
            .catch(error => console.log('error', error));


      setTimeout(function() {
        setCurrentBids(sortedBids);
        setCurrentNfts(sortedNfts);
        setMyNfts(allMyNfts);
        setGameNfts(allGameNfts);
        setBetaNfts(allBetaNft);
        setOpenNfts(sortedMarket);
        setBugsNfts(sortedBugsNfts);
        setPleaseWait(false);
      }, 6000);

    } else if (walletType=="walletconnect") {
      let allMyNfts =[];
      let allGameNfts =[];
      let allBetaNfts= [];
      if (!connector.connected) {
        // create new session
        connector.createSession();
      }
      const provider = new WalletConnectProvider({
        rpc: {
          43114: "https://api.avax.network/ext/bc/C/rpc"
        },
        chainId: 43114,
        bridge: "https://bridge.walletconnect.org",
        qrcodeModal: QRCodeModal,
      });
  
      await provider.enable();

      let web3Instance = new Web3(provider);
      let accounts = await web3Instance.eth.getAccounts();
      const abiInterface = new web3Instance.eth.Contract(abi,contractAdress);
      let allClaimBids = await abiInterface.methods.getClaimableBids(700).call({from: accounts[0]});
      let allClaimNfts = await abiInterface.methods.getClaimableNFTs(700).call({from: accounts[0]});
      let allMarketNfts = await abiInterface.methods.getUserAuctions(700).call({from: accounts[0]});
     // let allMyNfts = await abiInterface.methods.getUserTokenIds(nftAddress).call({from: accounts[0]});
      let allAuctionsList = await abiInterface.methods.getAuctionInfo(700).call();


      console.log(allClaimNfts);
      console.log(allClaimBids);
      let sortedBids =[];
      let sortedNfts =[];
      let sortedMarket=[];
      let sortedBugsNfts=[];

      for (let i = 0; i < allAuctionsList.auctionIds.length; i++) {
        if((allAuctionsList.owner[i]).toUpperCase()==(accounts[0]).toUpperCase() && (allAuctionsList.highestBidder[i]).toUpperCase()==(accounts[0]).toUpperCase() && allAuctionsList.auctionStates[i]=="2"){
          let isclaimed = await abiInterface.methods.isClaimed(allAuctionsList.auctionIds[i]).call();
          !isclaimed && sortedBugsNfts.push({
            auctionId: allAuctionsList.auctionIds[i],
            auctionNFTAddress: allAuctionsList.auctionNFTAddress[i],
            tokenId:allAuctionsList.tokenIds[i]
          })
        } 
      }
      for (let i = 0; i < allClaimBids.auctionIds.length; i++) {
        allClaimBids.auctionIds[i] !=0 && sortedBids.push({
          auctionId: allClaimBids.auctionIds[i],
          highestBid: allClaimBids.highestBid[i],
          auctionNFTAddress: allClaimBids.auctionNFTAddress[i],
          tokenId:allClaimBids.tokenIds[i]
        })
      }

      for (let i = 0; i < allMarketNfts.auctionIds.length; i++) {
        allMarketNfts.auctionNFTAddress[i] !="0x0000000000000000000000000000000000000000" && sortedMarket.push({
          auctionId: allMarketNfts.auctionIds[i],
          auctionNFTAddress: allMarketNfts.auctionNFTAddress[i],
          tokenId:allMarketNfts.tokenIds[i]
        })
      }

      for (let i = 0; i < allClaimNfts.auctionIds.length; i++) {
        allClaimNfts.auctionIds[i] !=0 && sortedNfts.push({
          auctionId: allClaimNfts.auctionIds[i],
          auctionNFTAddress: allClaimNfts.auctionNFTAddress[i],
          tokenId:allClaimNfts.tokenIds[i]
        })
      }

      var requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      await fetch("https://marketplaceapi.heroeschained.com/getnft?wallet="+accounts[0], requestOptions)
        .then(response => response.text())
        .then(result => {
          var jsonResult = JSON.parse(result);
          allMyNfts = jsonResult;
          console.log(jsonResult);
        })
        .catch(error => console.log('error', error));


        var requestOptions2 = {
          method: 'GET',
          redirect: 'follow'
        };
  
        await fetch("https://marketplaceapi.heroeschained.com/getgamenft?wallet="+accounts[0], requestOptions2)
          .then(response => response.text())
          .then(result => {
            var jsonResult = JSON.parse(result);
            allGameNfts = jsonResult;
            console.log(jsonResult);
          })
          .catch(error => console.log('error', error));

          var requestOptions3 = {
            method: 'GET',
            redirect: 'follow'
          };
    
          await fetch("https://marketplaceapi.heroeschained.com/getbetanft?wallet="+accounts[0], requestOptions3)
            .then(response => response.text())
            .then(result => {
              var jsonResult = JSON.parse(result);
              allBetaNfts = jsonResult;
              console.log(jsonResult);
            })
            .catch(error => console.log('error', error));
          
      setTimeout(function() {
        setCurrentBids(sortedBids);
        setCurrentNfts(sortedNfts);
        setMyNfts(allMyNfts);
        setGameNfts(allGameNfts);
        setBetaNfts(allBetaNfts);
        setOpenNfts(sortedMarket);
        setBugsNfts(sortedBugsNfts);
        setPleaseWait(false);
      }, 6000);
    }
    
  };

  useEffect(() => {
    getAllNfts();
  }, []);

  return (
<MarketplaceWrapper>
      <div className="nft-container">
        <div className="banner">
          <h1>My Wallet</h1>
          <h3>You can claim your bids or create a new auction</h3>
        </div>
        {pleaseWait && <img style={{width:'90px', height:'auto', margin:'auto'}} src="../wait.gif"/>}
        <div className="nft-items">

        {gameNfts && gameNfts.length > 0 && gameNfts.map((item, value) => (
            <div className='nft-card' onClick={() => modalAucOpen(item, "0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41")}>
            <div className="nft-options">
            <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item}</span>
            </div>
            <div className="img-container">
              <img src={"https://fov.heroeschained.com/api/NFT/FOVImage/"+item} alt="test-img" />
            </div>
            <div className="nft-info">
            <h6 style={{textAlign:'center'}}>{parseFoVTokenID(item.toString())}</h6>
              <div style={{ display: "grid", gap: ".5rem" }}>
                {/* <div className='nft-count'>
                  <span>1/1</span>
                </div> */}
                <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                  <div className='nft-price' style={{marginLeft:'20px'}}>
                    <div>
                      <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CREATE AUCTION</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

{betaNfts && betaNfts.length > 0 && betaNfts.map((item, value) => (
            <div className='nft-card' onClick={() => modalAucOpen(item, "0x9c9F19434D2f0154b3dc04913c9e02A0dD969E52")}>
            <div className="nft-options">
            <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item}</span>
            </div>
            <div className="img-container">
              <img style={{height:'200px'}} src={"https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"} alt="test-img" />
            </div>
            <div className="nft-info">
            <h6 style={{textAlign:'center'}}>The Skullscreamer #{item}</h6>
              <div style={{ display: "grid", gap: ".5rem" }}>
                <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                  <div className='nft-price' style={{marginLeft:'20px'}}>
                    <div>
                      <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CREATE AUCTION</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

        {myNfts && myNfts.length > 0 && myNfts.map((item, value) => (
            <div className='nft-card' onClick={() => modalAucOpen(item, nftAddress)}>
            <div className="nft-options">
            <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item}</span>
            </div>
            <div className="img-container">
              <img src={"https://mayinhara.s3.eu-central-1.amazonaws.com/images/"+item+".png"} alt="test-img" />
            </div>
            <div className="nft-info">
              <h3>MayinHara #{item}</h3>
              <div style={{ display: "grid", gap: ".5rem" }}>
                {/* <div className='nft-count'>
                  <span>1/1</span>
                </div> */}
                <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                  <div className='nft-price' style={{marginLeft:'20px'}}>
                    <div>
                      <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CREATE AUCTION</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}

      {openNfts && openNfts.length > 0 && openNfts.map((item, value) => (
                  <div className='nft-card'>
                  <div className="nft-options">
                  <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item.tokenId}</span>
                  </div>
                  <div className="img-container">
                    <img src={item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? "https://fov.heroeschained.com/api/NFT/FOVImage/"+item.tokenId : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? "https://mayinhara.s3.eu-central-1.amazonaws.com/images/"+item.tokenId+".png" : "https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"} alt="test-img" />
                  </div>
                  <div className="nft-info">
                    {item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? <h6 style={{textAlign:'center'}}>{parseFoVTokenID(item.tokenId.toString())}</h6> : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? <h3>MayinHara #{item.tokenId}</h3> : <h3>The Skullscreamer #{item.tokenId}</h3>}
                    <div style={{ display: "grid", gap: ".5rem" }}>
                      {/* <div className='nft-count'>
                        <span>1/1</span>
                      </div> */}
                      <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                        <div className='nft-price' style={{marginLeft:'20px'}}>
                          <div>
                            <span className="spanbutton" onClick={() => gotoAssets(`asset-${item.auctionId}`)} style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px', textAlign:'center'}}>Go To Asset</span>
                          </div>
                          <div>
                            <span className="spanbutton" onClick={() => cancelAuction(item.auctionNFTAddress, item.tokenId)} style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px', textAlign:'center'}}>Cancel Auction</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
        
            {currentBids && currentBids.length > 0 && currentBids.map((item, value) => (
                item.highestBid !="0" && <div className='nft-card' onClick={() => claimBid(item.auctionNFTAddress, item.tokenId)}>
                  <div className="nft-options">
                  <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item.tokenId}</span>
                  </div>
                  <div className="img-container">
                  <img src={item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? "https://fov.heroeschained.com/api/NFT/FOVImage/"+item.tokenId : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? "https://mayinhara.s3.eu-central-1.amazonaws.com/images/"+item.tokenId+".png" : "https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"} alt="test-img" />
                  </div>
                  <div className="nft-info">
                  {item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? <h6 style={{textAlign:'center'}}>{parseFoVTokenID(item.tokenId.toString())}</h6> : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? <h3>MayinHara #{item.tokenId}</h3> : <h3>The Skullscreamer #{item.tokenId}</h3>}
                    <div style={{ display: "grid", gap: ".5rem" }}>
                      {/* <div className='nft-count'>
                        <span>1/1</span>
                      </div> */}
                      <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                        <div className='nft-price' style={{marginLeft:'20px'}}>
                          <div>
                            <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CLAIM BIDS: <span style={{fontSize:'16px'}}>{(parseInt(item.highestBid)/(10**18)).toLocaleString('en-US')}</span></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
            ))}

            {currentNfts && currentNfts.length > 0 && currentNfts.map((item, value) => (
                  <div className='nft-card' onClick={() => claimBid(item.auctionNFTAddress, item.tokenId)}>
                  <div className="nft-options">
                  <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item.tokenId}</span>
                  </div>
                  <div className="img-container">
                  <img src={item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? "https://fov.heroeschained.com/api/NFT/FOVImage/"+item.tokenId : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? "https://mayinhara.s3.eu-central-1.amazonaws.com/images/"+item.tokenId+".png" : "https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"} alt="test-img" />
                  </div>
                  <div className="nft-info">
                  {item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? <h6 style={{textAlign:'center'}}>{parseFoVTokenID(item.tokenId.toString())}</h6> : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? <h3>MayinHara #{item.tokenId}</h3> : <h3>The Skullscreamer #{item.tokenId}</h3>}
                    <div style={{ display: "grid", gap: ".5rem" }}>
                      {/* <div className='nft-count'>
                        <span>1/1</span>
                      </div> */}
                      <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                        <div className='nft-price' style={{marginLeft:'20px'}}>
                          <div>
                            <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CLAIM NFT</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
            ))}

              {bugsNfts && bugsNfts.length > 0 && bugsNfts.map((item, value) => (
                  <div className='nft-card' onClick={() => claimBid(item.auctionNFTAddress, item.tokenId)}>
                  <div className="nft-options">
                  <span style={{padding:'0 5px', background:'orange', borderRadius:'10px'}}>#{item.tokenId}</span>
                  </div>
                  <div className="img-container">
                  <img src={item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? "https://fov.heroeschained.com/api/NFT/FOVImage/"+item.tokenId : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? "https://mayinhara.s3.eu-central-1.amazonaws.com/images/"+item.tokenId+".png" : "https://hcbw.s3.eu-central-1.amazonaws.com/the_skullscreamer2.png"} alt="test-img" />
                  </div>
                  <div className="nft-info">
                  {item.auctionNFTAddress=="0x6Ec27a4A9D5829FBb7CfC3440983BFA87e873f41" ? <h6 style={{textAlign:'center'}}>{parseFoVTokenID(item.tokenId.toString())}</h6> : item.auctionNFTAddress=="0xF7B6c94837d9fA6162EDA75F0909b21eE54534BB" ? <h3>MayinHara #{item.tokenId}</h3> : <h3>The Skullscreamer #{item.tokenId}</h3>}
                    <div style={{ display: "grid", gap: ".5rem" }}>
                      {/* <div className='nft-count'>
                        <span>1/1</span>
                      </div> */}
                      <div className="nft-sales" style={{textAlign:'center', justifyContent:'center', width:'100%'}}>
                        <div className='nft-price' style={{marginLeft:'20px'}}>
                          <div>
                            <span className="spanbutton" style={{border:'1px solid #ffbf36', borderRadius:'10px', padding:'5px', fontSize:'16px'}}>CLAIM NFT</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
            ))}

        </div>
      </div>
      <Modal
        keepMounted
        open={open}
        onClose={handleModal}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: '#14181d',
          border: '2px solid #14181d',
          boxShadow: 24,
          color: '#fff',
          padding: '10px',
          textAlign: 'center',
          borderRadius: '1rem',
        }}>
          <Typography variant="h6" component="h2">
            Auction Information
          </Typography>
          <Typography sx={{ mt: 2 }}>
            <Row className="mb-3">
              <Box
                component="form"
                sx={{
                  '& input': { color: "#fff", fontSize: "small" },
                  '& fieldset': { borderColor: "#fff" },
                  '& label': { color: "#fff", fontSize: "small" },
                  '.MuiSelect-select': { color: "#fff", fontSize: "small" },
                  '.MuiSvgIcon-root > path': { color: "#fff" }
                }}
                noValidate
                autoComplete="off"
              >
                <ToggleButtonGroup
                  color="primary"
                  value={alignment}
                  exclusive
                  onChange={handleChange}
                  sx={{
                    '.MuiButtonBase-root':{color:'white', marginBottom:'10px'}
                  }}
                >
                  <ToggleButton value="directbuy">Direct Buy</ToggleButton>
                  <ToggleButton value="auction">Auction</ToggleButton>
                </ToggleButtonGroup>

                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack spacing={3}>
                    <DateTimePicker
                      label={"End Time *"}
                      renderInput={(params) => <TextField {...params} />}
                      value={endTime}
                      onChange={(e) => { setEndTime(e); }}
                      minDateTime={Date.now()}
                    />
                  </Stack>
                </LocalizationProvider>
              </Box>
            </Row>
            <Row className="mb-3">
              <Box
                component="form"
                sx={{
                  '& input': { color: "#fff", fontSize: "small" },
                  '& fieldset': { borderColor: "#fff" },
                  '& label': { color: "#fff", fontSize: "small" },
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl id="minincrementid" fullWidth>
                  <TextField
                    onChange={(e) => setMinIncrement(e.target.value.replace(/(\.\d\d)\d+|([\d.]*)[^\d.]/, '$1$2'))}
                    value={minIncrement}
                    label={"Min Increment *"}
                    inputProps={{step:'0.01', pattern:"^\d*(\.\d{0,2})?$"}}
                    type="number"
                    fullWidth
                  />
                </FormControl>
              </Box>
            </Row>
            <Row className="mb-3">
              <Box
                component="form"
                sx={{
                  '& input': { color: "#fff", fontSize: "small" },
                  '& fieldset': { borderColor: "#fff" },
                  '& label': { color: "#fff", fontSize: "small" },
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl fullWidth>
                  <TextField
                    onChange={(e) => setDirectBuyPrice(e.target.value.replace(/(\.\d\d)\d+|([\d.]*)[^\d.]/, '$1$2'))}
                    value={directBuyPrice}
                    label={"Direct Buy Price"}
                    type="number"
                    fullWidth
                  />
                </FormControl>
              </Box>
            </Row>
            <Row className="mb-3">
              <Box
                component="form"
                sx={{
                  '& input': { color: "#fff", fontSize: "small" },
                  '& fieldset': { borderColor: "#fff" },
                  '& label': { color: "#fff", fontSize: "small" },
                }}
                noValidate
                autoComplete="off"
              >
                <FormControl id="startpriceid" fullWidth>
                  <TextField
                    onChange={(e) => setStartPrice(e.target.value.replace(/(\.\d\d)\d+|([\d.]*)[^\d.]/, '$1$2'))}
                    value={startPrice}
                    label={"Start Price *"}
                    type="number"
                    fullWidth
                  />
                </FormControl>
              </Box>
            </Row>
            <Row className="mb-3">
                <span style={{color:'#1976d2', textAlign:'left'}}>* Required Field</span>
            </Row>
            <Row className="mb-3">
              <Box sx={{
                '.MuiButton-root': { width: "100%", color:'orange' },
                '.MuiTouchRipple-root': {border:'1px solid orange'}
              }}>
                <Button onClick={createAuc} variant="outlined">Create</Button>
              </Box>
            </Row>
          </Typography>
          <Typography variant="h6" component="h2">
            NFT Detail
          </Typography>
                <div style={{width:'100%', height:'180px', overflow:'auto'}}>
                {
              nftAttribute && nftAttribute.map((nftitem, index) => (
                <div style={{width: index<2  ? '50%' : '25%', height:'80px', float:'left', border:'1px solid grey'}}>
                  <b style={{color:'orange'}}>{nftitem.trait_type.replace('Boost %','')}</b><br/>
                  {nftitem.value}
                </div>
                )) 
                }
                </div>

        </Box>
      </Modal>
    </MarketplaceWrapper >
  )
}

export default Wallet;